(() => {
  'use strict';
  const dialog = document.querySelector('[data-gg-email-popup]');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const form = dialog.querySelector('form');
  const emailInput = dialog.querySelector('[name="email"]');
  const submit = dialog.querySelector('[type="submit"]');
  const submitLabel = submit.querySelector('[data-gg-popup-submit-label]');
  const message = dialog.querySelector('#grwg-msg');
  const success = dialog.querySelector('#grwg-success');
  const intro = dialog.querySelector('[data-gg-popup-intro]');
  const cookieName = 'grwg_popup_v1';
  const subscriberCookie = 'grwg_newsletter_subscribed_v1';
  const shoppingCookie = 'grwg_popup_shopping_v1';
  const sessionKey = 'grwg_popup_seen_v1';
  const originalLabel = submitLabel.textContent;
  const configuredDelay = Number(dialog.dataset.delayMs);
  const delay = Number.isFinite(configuredDelay) ? Math.max(0, configuredDelay) : 30000;
  const dismissDays = Math.min(90, Math.max(1, Number(dialog.dataset.dismissDays) || 40));
  const demo = dialog.dataset.demo === 'true';
  let previousFocus = null;
  let previousOverflow = '';
  let pending = false;
  let submitted = false;
  let engaged = false;
  let cancelled = false;
  let shown = false;
  let timer;
  let visibleElapsed = 0;
  let visibleSince = document.visibilityState === 'visible' ? performance.now() : null;
  let lastInteraction = performance.now();

  const excludedPage = () => /(?:^|\/)(?:cart|checkouts?|orders|account)(?:\/|$)/i.test(location.pathname) || /\/pages\/(?:contact|for-professionals|for-retailers)(?:\/|$)/i.test(location.pathname) || Number(dialog.dataset.cartCount) > 0;
  const hasCookie = name => document.cookie.split(';').some(value => value.trim().startsWith(`${name}=`));
  const sessionSeen = () => { try { return sessionStorage.getItem(sessionKey) === '1'; } catch (error) { return false; } };
  const suppressed = () => hasCookie(cookieName) || hasCookie(subscriberCookie) || hasCookie(shoppingCookie) || sessionSeen();
  const remember = (name, days) => {
    if (demo) return;
    const expiry = days ? `;Max-Age=${days * 86400}` : '';
    document.cookie = `${name}=1${expiry};Path=/;SameSite=Lax${location.protocol === 'https:' ? ';Secure' : ''}`;
    try { sessionStorage.setItem(sessionKey, '1'); } catch (error) {}
  };
  const rememberDismissal = () => remember(cookieName, dismissDays);
  const rememberSubscriber = () => remember(subscriberCookie, 365);
  const pauseForShopping = () => {
    if (demo) return;
    cancelled = true;
    clearTimeout(timer);
    remember(shoppingCookie);
  };
  const editingForm = () => Boolean(document.activeElement && document.activeElement.matches('input,textarea,select,[contenteditable="true"],[role="textbox"],iframe'));
  const otherOverlay = () => {
    if (document.querySelector('.layout--viewport[data-drawer-status="opening"],.layout--viewport[data-drawer-status="opened"]')) return true;
    return Array.from(document.querySelectorAll('dialog[open]:not([data-gg-email-popup]),[aria-modal="true"]:not([data-gg-email-popup]),details.gg-ex-mobile[open],[data-gg-ex-disclosure][open]')).some(element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0);
  };
  const playingMedia = () => Array.from(document.querySelectorAll('video,audio')).some(media => !media.paused && !media.ended);
  const track = name => { if (!demo && window.gg && typeof window.gg.track === 'function') window.gg.track(name, {}); };

  function open() {
    if (dialog.open || submitted || cancelled) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    shown = true;
    rememberDismissal();
    dialog.querySelector('[data-gg-popup-dismiss]').focus({ preventScroll: true });
    track('gg_popup_view');
  }
  function close() {
    if (!dialog.open) return;
    rememberDismissal();
    cancelled = true;
    clearTimeout(timer);
    dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.querySelectorAll('[data-gg-popup-dismiss]').forEach(button => button.addEventListener('click', close));
  let backdropDown = false;
  dialog.addEventListener('pointerdown', event => {
    const rect = dialog.getBoundingClientRect();
    backdropDown = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
  });
  dialog.addEventListener('click', event => {
    if (!backdropDown || event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    backdropDown = false;
  });
  function attemptOpen() {
    if (shown || submitted || cancelled || excludedPage() || suppressed()) return;
    const now = performance.now();
    const visibleTime = visibleElapsed + (visibleSince === null ? 0 : now - visibleSince);
    if (visibleTime < delay || !engaged || document.visibilityState !== 'visible' || now - lastInteraction < 5000 || editingForm() || otherOverlay() || playingMedia()) {
      timer = setTimeout(attemptOpen, 1000);
      return;
    }
    open();
  }
  const noteScroll = () => {
    lastInteraction = performance.now();
    if (window.scrollY > 180) engaged = true;
  };
  const noteInteraction = event => {
    lastInteraction = performance.now();
    if (event.target instanceof Element && !event.target.closest('form,input,textarea,select,[contenteditable],dialog,a,button,summary') && window.innerWidth > 620) engaged = true;
  };
  if (demo) {
    document.addEventListener('gg:popup:preview', () => { cancelled = false; open(); });
  } else {
    if (document.querySelector('[data-gg-newsletter-success]')) rememberSubscriber();
    window.addEventListener('theme:cart:productAdded', pauseForShopping);
    window.addEventListener('theme:cart:open', pauseForShopping);
    document.addEventListener('submit', event => {
      if (event.target instanceof HTMLFormElement && /\/cart\/(?:add|change|update)(?:\.|\/|$)/.test(event.target.action)) pauseForShopping();
    }, true);
    if (!excludedPage() && !suppressed()) {
      window.addEventListener('scroll', noteScroll, { passive: true });
      document.addEventListener('pointerdown', noteInteraction, { passive: true });
      document.addEventListener('keydown', () => { lastInteraction = performance.now(); }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        const now = performance.now();
        if (visibleSince !== null) visibleElapsed += now - visibleSince;
        visibleSince = document.visibilityState === 'visible' ? now : null;
        lastInteraction = now;
      });
      timer = setTimeout(attemptOpen, Math.max(1000, delay));
    }
  }

  emailInput.addEventListener('input', () => {
    emailInput.removeAttribute('aria-invalid');
    message.textContent = '';
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending || submitted) return;
    emailInput.value = emailInput.value.trim();
    if (!emailInput.validity.valid || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
      emailInput.setAttribute('aria-invalid', 'true');
      message.textContent = dialog.dataset.invalidMessage;
      emailInput.focus({ preventScroll: true });
      return;
    }
    pending = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    submitLabel.textContent = dialog.dataset.loadingMessage;
    message.textContent = '';
    let timeout;
    try {
      if (demo) {
        await new Promise(resolve => setTimeout(resolve, 650));
        if (dialog.dataset.demoOutcome === 'error') throw new Error('Preview failure');
      } else {
        if (!dialog.dataset.companyId || !dialog.dataset.listId) throw new Error('Missing signup configuration');
        const controller = new AbortController();
        timeout = setTimeout(() => controller.abort(), 15000);
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(dialog.dataset.companyId)}`, {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: { custom_source: 'Growganica website email popup', profile: { data: { type: 'profile', attributes: {
              email: emailInput.value,
              properties: { source: dialog.dataset.source },
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } } },
            relationships: { list: { data: { type: 'list', id: dialog.dataset.listId } } }
          } })
        });
        if (response.status !== 202) throw new Error('Signup not accepted');
      }
      submitted = true;
      rememberSubscriber();
      form.hidden = true;
      intro.hidden = true;
      dialog.querySelector('.gg-email-popup__decline').hidden = true;
      success.hidden = false;
      dialog.setAttribute('aria-labelledby', 'grwg-success-title');
      dialog.removeAttribute('aria-describedby');
      if (dialog.open) success.focus({ preventScroll: true });
      track('gg_popup_signup');
    } catch (error) {
      message.textContent = dialog.dataset.errorMessage;
      submit.disabled = false;
      submitLabel.textContent = originalLabel;
      if (dialog.open) emailInput.focus({ preventScroll: true });
    } finally {
      clearTimeout(timeout);
      pending = false;
      form.removeAttribute('aria-busy');
    }
  });
})();
